import {ErrorCode, ErrorReason, parseErrorCode, parseErrorReason} from "./components/ErrorDisplay";
import {createQueryString} from "./tools";

export const pathName = "error";
export const path = "/" + pathName;

export const parse = (queryString: string): {id: ErrorReason; code: ErrorCode; path?: string} => {
    const params = new URLSearchParams(queryString);

    return {
        id: parseErrorReason(params.get("id")),
        code: params.get("code") ? parseErrorCode(params.get("code") || 404) : 404,
        path: params.get("path"),
    };
};

export const create = (code: ErrorCode, id: string, pathname?: string) => {
    const params: Record<string, any> = {id, code};
    if (pathname) params.pathname = pathname;

    return path + "?" + createQueryString(params);
};
